<template>
  <div>
    <el-upload
      v-if="fileList.length === 0"
      action="#"
      class="upload-box"
      :show-file-list="false"
      :http-request="handleHttpRequest"
    >
      <div class="upload-content">
        <img class="upload-icon" src="@/assets/upload/upload.png" alt="" />
        <div class="upload-content-title">
          <span style="color: #4076f2">点击</span>上传文件
        </div>
        <div class="upload-content-desc">支持 JPEG, PNG, PDF 格式</div>
      </div>
    </el-upload>
    <div v-else>
      <div class="upload-box">
        <div class="upload-content">
          <img class="upload-icon" src="@/assets/upload/upload.png" alt="" />
          <div class="upload-content-title-file">{{ fileObj.text }}</div>
          <div class="upload-content-detail" @click="handlePrescriptionImage">
            查看文件
          </div>
        </div>
        <div class="upload-edit-box">
          <i
            v-if="isDelete"
            class="el-icon-delete"
            style="cursor: pointer"
            @click="handleFileDelete"
          ></i>
          <div v-if="!isDelete"></div>
          <el-pagination
            background
            layout="pager"
            :page-size="1"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            :total="fileTotal"
          ></el-pagination>
        </div>
      </div>

      <TipDialog ref="TipDialogRef" @success="handleSuccess" />
      <PrescriptionImage ref="PrescriptionImageRef" :fileObj="fileObj" />
    </div>
  </div>
</template>

<script>
import TipDialog from "@/components/TipDialog/index.vue";
import PrescriptionImage from "@/components/PrescriptionImage/index.vue";

export default {
  name: "DocumentUpload",
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    isDelete: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    fileList: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.fileObj = newVal[0];
          this.fileTotal = newVal.length;
          this.currentPage = 1;
        }
      },
      deep: true,
    },
  },
  components: {
    TipDialog,
    PrescriptionImage,
  },
  data() {
    return {
      // fileList: [],
      fileObj: {},
      fileTotal: 0,
      currentPage: 1,
    };
  },
  methods: {
    reset() {
      this.fileList = [];
      this.fileObj = {};
      this.fileTotal = 0;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.fileObj = this.fileList[val - 1];
      this.$forceUpdate();
    },
    handleBeforeUpload(file) {
      const isValidType =
        file.type === "image/jpeg" || file.type === "application/pdf";
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isValidType) {
        this.$message.error("只能上传 JPEG 或 PDF 格式的文件");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("文件大小不能超过 10MB");
        return false;
      }
      return true;
    },
    async handleHttpRequest(options) {
      const formData = new FormData();
      formData.append("file", options.file);
      try {
        this.$emit("loading", true);
        const { data } = await this.$api.upload.AnalysisUpload(formData);
        this.fileList = data.imgs;
        this.fileObj = data.imgs[0];
        this.fileTotal = data.imgs.length;
        this.$emit("loading", false);
        this.$emit("successUpload", data);
      } catch (error) {
        this.$emit("loading", false);
        this.$message.error("识别失败");
      }
    },
    handleFileDelete() {
      this.$refs.TipDialogRef.show({
        title: "文件删除",
        content: "文件删除后，文字框内识别内容将重置，是否删除？",
        successText: "确认",
        isTime: true,
      });
    },
    async handleSuccess() {
      this.reset();
      this.$emit("successDelete");
    },
    handlePrescriptionImage() {
      this.$refs.PrescriptionImageRef.show();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
